
export enum BillStatusCd {
	BILLED = 'Billed',
	CANCELLED = 'Cancelled',
	IN_FBES_SUSPENSE_QUEUE = 'InFbesSuspenseQueue',
	PAID = 'Paid',
	RATED = 'Rated',
	UNBILLED = 'Unbilled'}

